import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SpamEmailModel } from './typings/security.spam-email';

@Component({
  template: require('./security.spam-protection.actions.component.html')
})
export class SpamProtectionActionsComponent {
  @Input() record: SpamEmailModel;

  @Output() onOverrideClick: EventEmitter<SpamEmailModel> = new EventEmitter();
}
